import {NgModule, Optional, SkipSelf} from '@angular/core';
import {throwIfAlreadyLoaded} from './module-import-guard';
import {Configuration} from '../lib/core/common/configuration';
import {SettingService} from '../lib/core/common/settings.service';
import {TranslatorService} from '../lib/core/translator/translator.service';
import {UtilsService} from '../lib/core/common/utils/utils.service';
import {DateUtilService} from '../lib/core/common/utils/date_util.service';
import {ToastService} from '../lib/core/toaster/toast.service';
import {StoreService} from '../lib/core/common/store/store.service';
import {RoutingService} from '../lib/core/common/routing.service';
import {ToastrModule} from 'ngx-toastr';
import {MenuService} from "../lib/core/menu/menu.service";


@NgModule({
  imports: [
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
  ],
  providers: [
    Configuration,
    SettingService,
    MenuService,
    TranslatorService,
    UtilsService,
    DateUtilService,
    ToastService,
    StoreService,
    RoutingService
  ],
  declarations: [],
  exports: []
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
